import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { StaffDisability } from 'src/app/model/user/staff-disbility.model';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class StaffTypeOfDisabilityService {
    httpOptions = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json; charset=utf-8'
        })
    };
    version = 'v1.0';
    url = environment.apiUrl + this.version + '/DisStaffTypeOfDisability';
    constructor(private http: HttpClient) {
    }
    getStaffTypeOfDisability(filter: any): Observable<any> {
        let queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
        return this.http.get(this.url + '/GetSelectPaging?' + queryString);
    }

    addMultiple(model): Observable<any> {
        return this.http.post(this.url + '/GetSelectPagingAddMultiple', model, this.httpOptions);
    }

    getStaffTypeOfDisabilityById(id: any): Observable<any> {
        return this.http.get(this.url + `/GetSelectPagingById/${id}`, this.httpOptions);
    }
    deleteMulti(listId: number[]): Observable<any> {
        return this.http.post(this.url + `/GetSelectPagingDeleteMulti`, listId, this.httpOptions);
    }
    update(model: StaffDisability): Observable<any> {
        return this.http.put(this.url + `/GetSelectPagingUpdate/${model.id}`, model, this.httpOptions);
    }
    exportExcel(filter: any): Observable<any> {
        filter = JSON.parse(JSON.stringify(filter));
        delete filter.PageIndex; delete filter.PageSize; 
        let queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
        return this.http.get(this.url + '/GetSelectPagingExport?' + queryString, { responseType: 'blob' as 'json' });
    }
}
